import styled from 'styled-components'
import { Video } from '../Video/Video'

export const SquareVideo = styled(Video)`
  aspect-ratio: 1;
`
